<!-- Loading Screen durante l'inizializzazione -->
@if (isAppLoading$ | async) {
  <div class="vh-100 d-flex flex-column align-items-center justify-content-center">
    <app-loading></app-loading>
  </div>
} @else {
  <!-- App normale una volta caricata -->
  <div class="app-container">
    @if (!isBackoffice && !isMaintenancePage) {
      <app-header></app-header>
    }

    <main class="main-content" [style.margin-top.px]="isMaintenancePage ? 0 : 75" [class.no-header]="isBackoffice || isMaintenancePage" [class.maintenance-active]="!isMaintenancePage && !isBackoffice">
      <router-outlet></router-outlet>
    </main>

    @if (!isBackoffice && !isMaintenancePage) {
      <app-footer></app-footer>
    }
  </div>
}